import {
    Box, Divider, Flex, Grid, IconButton, Image, Text, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, FormControl, FormLabel, Input, Button, FormErrorMessage,
    useDisclosure,
} from "@chakra-ui/react";
import { useState } from "react";
import EmergencyLogo from '../../../../../assets/images/EmergencyLogo.svg';
import EditLogo from "../../../../../assets/images/EditLogo.svg";
import { EmployeePersonalInfo } from "./modal";
import { Controller, useForm } from "react-hook-form";
import { useFetch } from "../../../../../hooks/useFetch";
import { CustomToast } from "../../../../../components";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { EmergencyContacts } from "./modal";
import { useAuth } from "../../../../../hooks/useAuth";

interface Props {
    employeeId: number | null;
    personalDetail?: EmployeePersonalInfo;
    reload: () => void;
}

export interface IAddress {
    empId?: number | null;
    emergency_Contact_Name: string;
    emergency_Contact_Number: string;
};

const unmask = (val: string) => val.replace(/\D/g, "");


const EmergencyContact = ({ employeeId, personalDetail, reload }: Props) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const { hasPermission } = useAuth();

    const AddressSchema: any = yup.object().shape({
        emergency_Contact_Name: yup.string().required("Emergency contact name is rquired").matches(/^[A-Za-z\s]+$/, "Name can only contain letters and spaces"),
        emergency_Contact_Number: yup.string().required("Emergency contact number is rquired").test("len", "Phone number must be exactly 10 digits", (val) => unmask(val || "").length === 10)
            .test("different-phone", "Emergency Contact Number cannot be the same as Personal Phone Number",
                function (value) {
                    const emergency = unmask(value || ""); const personal = unmask(personalDetail?.phone_Number || "");
                    return emergency !== personal;
                }
            ),
    })

    const { control, handleSubmit, register, formState: { errors, isSubmitting }, reset } = useForm<IAddress>({
        resolver: yupResolver(AddressSchema),
        defaultValues: {
            emergency_Contact_Name: personalDetail?.emergency_Contact_Name || "",
            emergency_Contact_Number: personalDetail?.emergency_Contact_Number || "",
        },
    });

    function handleEditClick() {
        reset({
            emergency_Contact_Name: personalDetail?.emergency_Contact_Name,
            emergency_Contact_Number: personalDetail?.emergency_Contact_Number,
        });
        onOpen();
    }

    const onSubmit = async (data: IAddress) => {
        data.empId = employeeId;
        let endpoint = `Hrlense_Employee/personalDetail/${employeeId}`;
        const response = await fetchApi(endpoint, "PUT", data, null, "Emergency Contact Details Updated");
        if (response) {
            reload();
            onClose();
        }
    }

    const maskPhone = (val: string) => {
        const digits = val.replace(/\D/g, "").slice(0, 12);
        if (digits.length > 5) {
            return digits.slice(0, 5) + " " + digits.slice(5);
        }
        return digits;
    };

    return (
        <>
            <Box pt={2} mb={6} className="main">
                <Flex justify="space-between" align="center" mb={2} pl={5} pr={5}>
                    <Flex align="center" gap={3}>
                        <Image src={EmergencyLogo} alt={"Benifits & ID Numberss"} />
                        <Text className="font-poppins text_sm text_medium col">
                            Emergency Contact
                        </Text>
                    </Flex>
                    {hasPermission("Employee", "UpdateEmergencyContact") && (
                        <IconButton aria-label="Edit" icon={<Image src={EditLogo} />} variant="none" onClick={() => handleEditClick()} />
                    )}
                </Flex>

                <Box py={2} px={10} bg="#FFFFFF" borderRadius={8}>
                    {EmergencyContacts.map((data, index) => {
                        let value = personalDetail?.[data?.key] as string;
                        if (data?.key === "emergency_Contact_Number" && value) {
                            value = maskPhone(value);
                        }
                        return (
                            <Grid key={index} templateColumns="1fr 1fr" alignItems="center" mb={2}>
                                <Text
                                    className="font-poppins text_sm text_medium"
                                    color="rgba(102, 102, 102, 1)"
                                    
                                >
                                    {data?.label}
                                </Text>
                                <Text className="font-poppins text_sm text_medium col">
                                    {personalDetail?.[data?.key]}
                                </Text>
                            </Grid>
                        )
                    })}
                    {/* <Divider mt={2} /> */}
                </Box>
            </Box>


            {/* Drawer for editing */}
            <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>Update Emergency Contact</DrawerHeader>
                    <DrawerBody>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <FormControl isInvalid={!!errors.emergency_Contact_Name} isRequired mb={4}>
                                <FormLabel> Emergency Contact Name </FormLabel>
                                <Controller
                                    name="emergency_Contact_Name" control={control}
                                    render={({ field }) => (
                                        <Input type="string"  {...field} />
                                    )}
                                />
                                <FormErrorMessage>{errors.emergency_Contact_Name?.message}</FormErrorMessage>
                            </FormControl>

                            <FormControl isInvalid={!!errors.emergency_Contact_Number} isRequired mb={4}>
                                <FormLabel> Emergency Contact Number </FormLabel>
                                <Controller
                                    name="emergency_Contact_Number" control={control}
                                    render={({ field }) => (
                                        <Input type="string"  {...field}
                                            value={maskPhone(field.value || "")}
                                            onChange={(e) => field.onChange(maskPhone(e.target.value))}
                                        />
                                    )}
                                />
                                <FormErrorMessage>{errors.emergency_Contact_Number?.message}</FormErrorMessage>
                            </FormControl>

                            <Box mt={6} textAlign="right">
                                <Button type="submit" className="btn_theme btn_theme:hover" isLoading={isSubmitting}>
                                    Update
                                </Button>
                            </Box>
                        </form>

                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </>

    );
};

export default EmergencyContact;
